import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { scrollToTop } from '../../utils/scrollHelper';

const FooterContainer = styled.footer`
  background-color: var(--dark);
  color: white;
  padding: 3rem 0 1.5rem;
  margin-top: 4rem;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterColumn = styled.div`
  h3 {
    color: white;
    font-size: 1.2rem;
    margin-bottom: 1.25rem;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: var(--primary);
    }
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    margin-bottom: 0.75rem;
  }
  
  a {
    color: #e0e0e0;
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: var(--primary-light);
    }
  }
`;

const FooterSocial = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: var(--primary);
      transform: translateY(-3px);
    }
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
  color: #a0a0a0;
  
  a {
    color: #e0e0e0;
    text-decoration: none;
    
    &:hover {
      color: var(--primary-light);
    }
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  
  // Enhanced navigation handler that ensures scroll to top
  const handleNavigation = (to) => (e) => {
    e.preventDefault();
    scrollToTop();
    navigate(to);
  };
  
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterColumn>
            <h3>Dozzy.au</h3>
            <p>Helping parents and children get the sleep they deserve with personalized, evidence-based sleep plans.</p>
            {/*<FooterSocial>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-twitter"></i>
              </a>
            </FooterSocial>*/}
          </FooterColumn>
          
          <FooterColumn>
            <h3>Quick Links</h3>
            <FooterLinks>
              <li><a href="/" onClick={handleNavigation('/')}>Home</a></li>
              <li><a href="/about" onClick={handleNavigation('/about')}>About Us</a></li>
              <li><a href="/faq" onClick={handleNavigation('/faq')}>FAQ</a></li>
              <li><a href="/pricing" onClick={handleNavigation('/pricing')}>Pricing</a></li>
              <li><a href="/gift" onClick={handleNavigation('/gift')}>Give the Gift of Sleep</a></li>
              <li><a href="/signup" onClick={handleNavigation('/signup')}>Get Your Personalized Sleep Plan</a></li>
              <li><a href="/login" onClick={handleNavigation('/login')}>Account Login</a></li>
              <li><a href="/contact" onClick={handleNavigation('/contact')}>Contact</a></li>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn>
            <h3>Parent Support</h3>
            <FooterLinks>
              <li><a href="https://www.ruok.org.au/" target="_blank" rel="noopener noreferrer">R U OK?</a></li>
              <li><a href="https://www.beyondblue.org.au/" target="_blank" rel="noopener noreferrer">Beyond Blue</a></li>
              <li><a href="https://www.gidgetfoundation.org.au/" target="_blank" rel="noopener noreferrer">Gidget Foundation</a></li>
              <li><a href="https://www.panda.org.au/" target="_blank" rel="noopener noreferrer">PANDA</a></li>
              <li><a href="https://www.lifeline.org.au/" target="_blank" rel="noopener noreferrer">Lifeline</a></li>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn>
            <h3>Legal</h3>
            <FooterLinks>
              <li><a href="/terms-and-conditions" onClick={handleNavigation('/terms-and-conditions')}>Terms & Conditions</a></li>
              <li><a href="/privacy-policy" onClick={handleNavigation('/privacy-policy')}>Privacy Policy</a></li>
              <li><a href="/acknowledgement" onClick={handleNavigation('/acknowledgement')}>Acknowledgement of Country</a></li>
            </FooterLinks>
          </FooterColumn>
          
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; {currentYear} Dozzy.au. All rights reserved.</p>
          <p>Sleep plans based on guidelines from <a href="https://www.triplep.net/glo-en/home/" target="_blank" rel="noopener noreferrer">Triple P</a>, <a href="https://rednose.org.au/" target="_blank" rel="noopener noreferrer">Red Nose Australia</a>, <a href="https://raisingchildren.net.au/" target="_blank" rel="noopener noreferrer">Raising Children Network</a>, and <a href="https://www.tresillian.org.au/" target="_blank" rel="noopener noreferrer">Tresillian</a>.</p>
        </FooterBottom>
      </div>
    </FooterContainer>
  );
};

export default Footer;
